import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import PublicDataSearch from '@/src/javascripts/public_data/PublicDataSearch.vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'

$(document).on('turbo:load turbo:render', () => {
  const publicDataIndex = document.querySelector('#public-data-index')
  if (publicDataIndex && !publicDataIndex.__vue_app__) {
    const deletePublicData = async (id, token) => {
      const isConfirm = await mySwal.confirm({
        title: '確認是否要刪除資料？',
        confirmButtonText: '是',
        cancelButtonText: '否',
        confirmButtonColor: '#0e3884'
      })

      if (!isConfirm) {
        return
      }

      $.ajax({
        url: `/public_data/${id}`,
        type: 'DELETE',
        dataType: 'json',
        headers: { 'X-CSRF-Token': token },
        authenticity_token: true,
        success: async (response) => {
          if (response.state === 0) {
            Turbo.visit('/public_data')
          }
        },
        error: (error) => {
          console.log('error', error)
          if (error.responseJSON.state === -1) {
            mySwal.error({
              title: error.responseJSON.message.join('<br />')
            })
          }
        }
      })
    }

    createApp({
      components: { BaseAlert, PublicDataSearch },
      setup () {
        return {
          deletePublicData
        }
      }
    }).mount(publicDataIndex)
  }
})
